import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./styles/tooltip-navy.css";
import { initPostHog } from "./lib/analytics";

// Initialize PostHog at boot only if the user already accepted analytics
// in a previous visit. Otherwise it stays dormant until they click Accept.
void initPostHog();

createRoot(document.getElementById("root")!).render(<App />);
